import {Query, gql} from 'apollo-angular';
import { Injectable } from '@angular/core';



@Injectable({
    providedIn: 'root'
})
export class EventQuery extends Query<any> {
    document = gql`
        query Turbines(
          $serialNav: Float!, 
          $fromTS: Float!,
          $toTS: Float!,
          $capped: Boolean,
          $pageSize: Int,
          $pageNumber: Int,
          $lastPage: Boolean,
          $eventCodeFilter: String,
          $eventCodeExcludeFilter: String,
          $eventCodeExceptionFilter: [String]) {
            turbines(where: { serialNav: $serialNav }) {
                turbineLogbook(
                  startTS: $fromTS,
                  endTS: $toTS,
                  capped: $capped,
                  pageSize: $pageSize,
                  pageNumber: $pageNumber,
                  lastPage: $lastPage,
                  eventCodeFilter: $eventCodeFilter,
                  eventCodeExcludeFilter: $eventCodeExcludeFilter,
                  eventCodeExceptionFilter: $eventCodeExceptionFilter
                ) {
                    turbineLogbookEvents {
                      totalCount
                      events {
                        _id
                        code
                        createTS
                        type
                        description
                      }
                    }
                }
            }
        }
    `;
}
